module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1944156"
    }
  }, [_c('b', [_vm._v("VEGETABLE CHOWDER")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1944656"
    }
  }, [_c('b', [_c('i', [_vm._v("If you have your own vegetable garden or if you live near a farmers’ market, you will want to make this luscious soup to take advantage of the fresh summer produce.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1946356"
    }
  }, [_c('b', [_vm._v("Prep: 15 minutes Cook: 30 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1946856"
    }
  }, [_vm._v("2 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1947156"
    }
  }, [_vm._v("1 large onion (12 ounces), chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1947456"
    }
  }, [_vm._v("3 cups water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1948056"
    }
  }, [_vm._v("3 medium zucchini and/or yellow summer squashes "), _c('br'), _vm._v(" (about 8 ounces each), coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1948656"
    }
  }, [_vm._v("2 red and/or yellow peppers, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1949056"
    }
  }, [_vm._v("3 large ripe tomatoes (2 pounds), coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1949356"
    }
  }, [_vm._v("3 large garlic cloves, crushed with garlic press")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1949656"
    }
  }, [_vm._v("½ teaspoon fennel seeds")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1950556"
    }
  }, [_vm._v("2 teaspoons salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1950956"
    }
  }, [_vm._v("¼ teaspoon ground black pepper "), _c('br'), _vm._v(" sliced fresh basil leaves for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1952356"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 5-quart saucepot or Dutch oven, heat oil over medium-high heat. Add onion and cook until tender and lightly browned, about 10 minutes. Add water, zucchini and/or yellow squashes, peppers, tomatoes, garlic, fennel seeds, salt, and black pepper; heat to boiling. Reduce heat to medium and cook, uncovered, until vegetables are tender, about 20 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1955456"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Spoon one-third of the mixture into blender; cover, with center part of cover removed to let steam escape, and puree until smooth. Pour puree into bowl. Repeat with remaining mixture.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1957356"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" To serve hot, return soup to same clean saucepot and heat through. To serve cold, cover and refrigerate at least 4 hours. Garnish with sliced basil. Makes about 9 cups or 6 main-dish servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1959556"
    }
  }, [_vm._v("Each serving: About 120 calories, 4g protein, 18g carbohydrate, 5g total fat (1g saturated), 0mg cholesterol, 795mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cdc2a82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c54_r1.vue
// module id = 228
// module chunks = 0